module.exports = __webpack_public_path__ + "static/media/SectionGeometry.cfaa8b07.svg";